
import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
    adType: 'banner'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4l1tq232n60g3bh7s9g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          message: '',
          adType: 'banner'
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center space-y-6">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-6xl lg:text-7xl font-black text-white"
          >
            Contacto y <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500">Publicidad</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            Llega a miles de amantes del entretenimiento con tu mensaje
          </motion.p>
        </div>
      </section>

      {/* Main Content */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Side - Info */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-8"
            >
              <div className="relative rounded-3xl overflow-hidden">
                <div className="w-full h-96">
                  <img
                    src="https://public.readdy.ai/ai/img_res/ed3de0e3af675926c9b3273e5eea5140.jpg"
                    alt="Publicidad"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h2 className="text-4xl font-black text-white mb-2">
                    Impulsa tu Marca
                  </h2>
                  <p className="text-gray-300 text-lg">
                    Con nuestra audiencia comprometida
                  </p>
                </div>
              </div>

              <div className="space-y-6">
                <div className="p-6 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-white/10">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-pink-500 to-purple-500">
                      <i className="ri-user-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-lg mb-2">Audiencia Comprometida</h3>
                      <p className="text-gray-400 text-sm">
                        Más de 50,000 usuarios activos mensuales apasionados por el entretenimiento
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-6 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-white/10">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-cyan-500 to-blue-500">
                      <i className="ri-bar-chart-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-lg mb-2">Resultados Medibles</h3>
                      <p className="text-gray-400 text-sm">
                        Reportes detallados de impresiones, clics y conversiones de tu campaña
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-6 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-white/10">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-purple-500 to-pink-500">
                      <i className="ri-palette-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-lg mb-2">Formatos Personalizados</h3>
                      <p className="text-gray-400 text-sm">
                        Banners, videos, contenido patrocinado y menciones en transmisiones en vivo
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right Side - Form */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl border border-white/10 p-8">
                <h2 className="text-3xl font-black text-white mb-2">
                  Solicita Información
                </h2>
                <p className="text-gray-400 mb-8">
                  Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas para discutir las mejores opciones para tu marca
                </p>

                <form onSubmit={handleSubmit} data-readdy-form id="contact_form" className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-white text-sm font-medium mb-2">
                      Nombre Completo *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 text-sm outline-none focus:border-pink-500 transition-colors"
                      placeholder="Tu nombre"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 text-sm outline-none focus:border-pink-500 transition-colors"
                      placeholder="tu@email.com"
                    />
                  </div>

                  <div>
                    <label htmlFor="company" className="block text-white text-sm font-medium mb-2">
                      Empresa
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 text-sm outline-none focus:border-pink-500 transition-colors"
                      placeholder="Nombre de tu empresa"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-white text-sm font-medium mb-2">
                      Teléfono
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 text-sm outline-none focus:border-pink-500 transition-colors"
                      placeholder="+34 600 000 000"
                    />
                  </div>

                  <div>
                    <label htmlFor="adType" className="block text-white text-sm font-medium mb-2">
                      Tipo de Publicidad *
                    </label>
                    <select
                      id="adType"
                      name="adType"
                      value={formData.adType}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white text-sm outline-none focus:border-pink-500 transition-colors cursor-pointer"
                    >
                      <option value="banner">Banner Publicitario</option>
                      <option value="video">Video Promocional</option>
                      <option value="sponsored">Contenido Patrocinado</option>
                      <option value="live">Mención en Transmisión en Vivo</option>
                      <option value="newsletter">Newsletter</option>
                      <option value="other">Otro</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-white text-sm font-medium mb-2">
                      Mensaje *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 text-sm outline-none focus:border-pink-500 transition-colors resize-none"
                      placeholder="Cuéntanos sobre tu proyecto y objetivos..."
                    ></textarea>
                    <p className="text-gray-500 text-xs mt-1">
                      {formData.message.length}/500 caracteres
                    </p>
                  </div>

                  {submitStatus === 'success' && (
                    <div className="p-4 bg-green-500/20 border border-green-500/50 rounded-lg">
                      <p className="text-green-400 text-sm flex items-center space-x-2">
                        <i className="ri-checkbox-circle-fill"></i>
                        <span>¡Mensaje enviado con éxito! Te contactaremos pronto.</span>
                      </p>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="p-4 bg-red-500/20 border border-red-500/50 rounded-lg">
                      <p className="text-red-400 text-sm flex items-center space-x-2">
                        <i className="ri-error-warning-fill"></i>
                        <span>Hubo un error. Por favor, intenta de nuevo.</span>
                      </p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-pink-500/50 transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin"></i>
                        <span>Enviando...</span>
                      </>
                    ) : (
                      <>
                        <span>Enviar Solicitud</span>
                        <i className="ri-arrow-right-line"></i>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 p-1 rounded-3xl"
          >
            <div className="bg-black rounded-3xl p-12">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-black text-white mb-4">Otras Formas de Contacto</h2>
                <p className="text-gray-300 text-lg">Estamos disponibles en múltiples canales</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center space-y-4">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-gradient-to-br from-pink-500 to-purple-500">
                    <i className="ri-mail-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-white font-bold text-xl">Email</h3>
                  <a href="mailto:publicidad@mediastream.com" className="text-gray-300 hover:text-pink-500 transition-colors">
                    publicidad@mediastream.com
                  </a>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-gradient-to-br from-cyan-500 to-blue-500">
                    <i className="ri-telegram-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-white font-bold text-xl">Telegram</h3>
                  <a href="https://t.me/TV_Plus17" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-cyan-500 transition-colors">
                    @TV_Plus17
                  </a>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-gradient-to-br from-purple-500 to-pink-500">
                    <i className="ri-phone-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-white font-bold text-xl">Teléfono</h3>
                  <a href="tel:+34900123456" className="text-gray-300 hover:text-purple-500 transition-colors">
                    +34 900 123 456
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
